// src/App.tsx
import React from 'react';
import ChatScreen from './components/ChatScreen';

const App: React.FC = () => {
  return (
    <div>
      <ChatScreen />
    </div>
  );
};

export default App;
